import { useState } from "react";
import config from "../config";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getMiroUserId } from "../refractCommon/utils/useDataStoreMiro";
import { IsProState } from "../refractCommon/utils/useFirestore";

export default function Pro({
  // TODO: stop using isPro in favor of userData
  isPro,
  //  setIsPro,
}: {
  isPro?: IsProState
  //  setIsPro: Dispatch<React.SetStateAction<boolean | undefined>>
}) {

  const [proSpinner, setProSpinner] = useState<boolean>(false)

  async function openCustomerPortal() {
    setProSpinner(true);
    try {
      const functions = getFunctions();
      //connectFunctionsEmulator(functions, "localhost", 5001);
      const createPortalSession = httpsCallable(functions, "createPortalSession");
      const result = (await createPortalSession({})) as any;
      const url = result?.data?.session?.url;
      if (url) {
        window.open(url, "_blank");
      } else {
        console.error("No URL:", result)
      }
    } catch (error) {
      console.error(error)
    }
    setTimeout(() => setProSpinner(false), 1000);
  }

  return (
    <>
      {config.features.buyPro && (
        <>
          {isPro === false && (
            <button
              type="button"
              className="button-secondary button button-small mb-0 mt-0 pt-0 pb-0 cs8 ce12 fix-stupid-button "
              onClick={async () => {
                const stripeUrl =
                  "https://buy.stripe.com/test_5kAaIg3YRfFw4246oo?client_reference_id=" +
                  await getMiroUserId();
                window.open(stripeUrl, "_blank");
              }}>
              Buy <b>Pro</b>
            </button>
          )}

          {isPro === true && (
            <button
              type="button"
              className={"button-secondary button button-small mb-0 mt-0 pt-0 pb-0 cs8 ce12 fix-stupid-button " + (proSpinner ? " button-loading" : '')}
              onClick={openCustomerPortal}>
              You have <b>Pro</b>
            </button>
          )}
        </>
      )}

      {!config.features.buyPro && (
        <button
          type="button"
          className="button-secondary button button-small mb-0 mt-0 pt-0 pb-0 cs8 ce12 fix-stupid-button "
          onClick={async () => {
            window.open("https://www.visualthinking.tools/powerpack-feedback/#comp-l3alhyjs", "_blank");
          }}>
          Register for <b>Pro</b>
        </button>
      )}
    </>
  );
}
